export const STORE_ROOT = 'rootStore';
export const STORE_COMMON = 'commonStore';
export const STORE_AUTH = 'authStore';
export const STORE_NOTIFICATION = 'notificationStore';
export const STORE_CREATE_EDIT_CUSTOMER_ORDER = 'createEditCustomerOrderStore';
export const STORE_CUSTOMER_ORDERS = 'customerOrdersStore';
export const STORE_REJECTIONS = 'rejectionsStore';
export const STORE_CUSTOMERS = 'customersStore';
export const STORE_REPORT1 = 'report1Store';
export const STORE_REPORT2 = 'report2Store';
export const STORE_REPORT3 = 'report3Store';
export const STORE_DEMANDS = 'demandsStore';
export const STORE_ACCEPTANCES = 'acceptancesStore';
export const STORE_PRINT = 'printStore';
export const STORE_SEARCH_HISTORY = 'searchHistoryStore';
export const STORE_KASSES = 'kassesStore';
export const STORE_ORDERS_NOTIFICATION = 'ordersNotificationStore';
export const STORE_CDEK = 'cdekStore';
export const STORE_VIN_QUERIES = 'vinQueriesStore';
export const STORE_USERS = 'usersStore';